<template>
  <div
    v-if="item && item.prevTenderStatus && item.newTenderStatus && item.prevTenderStatus.id !== item.newTenderStatus.id"
    class="event-history"
    :data-qa="dataQa + '-change-state'">
    <span class="event-history_prefix">
      <UserIcon
        class="avatar"
        size="35">
        <sIcon
          color="var(--white-color)"
          type="tag-auto"/>
      </UserIcon>
      <div
        :data-qa="`${dataQa}-auto`">
        {{ $t('Common.Automatically') }}
      </div>
    </span>
    <span class="event-history_label">
      {{ $t('Tenders.StatusChanges') }}
    </span>
    <span>{{ $t('Common.From') }}</span>
    <StatusChip
      class="font-size-12"
      :data-qa="`${dataQa}-status-${item.prevTenderStatus.id}`"
      key-name="id"
      :status="item.prevTenderStatus"
      value-name="title"/>
    <span>
      {{ $t('Common.To') }}
    </span>
    <StatusChip
      class="font-size-12"
      :data-qa="`${dataQa}-status-${item.newTenderStatus.id}`"
      key-name="id"
      :status="item.newTenderStatus"
      value-name="title"/>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'

import historyMixin from 'components/common/blocks/history/layout/historyMixin.js'

export default {
  name: 'LayoutHistoryChangeState',
  mixins: [ historyMixin ],
  components: {
    UserIcon,
    StatusChip,
  },
}
</script>
<style scoped lang="scss">
.event-history {
  display: grid;
  grid-template-rows: auto auto auto auto;
  gap: 5px;
  &_label {
    text-decoration: underline;
    font-size: 14px;
    grid-row: 1;
    grid-column: 1 / span 4;
    line-height: 21px;
  }
  &_prefix {
    display: none;
    line-height: 21px;
    gap: 5px;
    align-items: center;
  }
  @container (min-width:800px) {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &_label {
    }
    &_prefix {
      display: flex;
    }
  }
}
</style>
